import { Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ProductListTab } from './state';
import useProductListCounts from './useProductListCounts';

interface ProductListTabsProps {
  tab: ProductListTab;
  onChange: (tab: ProductListTab) => void;
}

export default function ProductListTabs({ tab, onChange }: ProductListTabsProps): React.JSX.Element {
  const { t } = useTranslation(['products']);
  const { allProductsCount, namesToOptimizeCount } = useProductListCounts();

  return (
    <Tabs
      value={tab}
      onChange={(event, newTab: ProductListTab) => onChange(newTab)}
      sx={{ px: 1, mb: 4, borderBottom: 1, borderColor: 'outlineVariant.main' }}
    >
      <Tab value="ALL" label={t('products:name_optimization.all_tab', { count: allProductsCount })} sx={{ typography: 'titleSmall' }} />
      <Tab value="NAME_TO_OPTIMIZE" label={t('products:name_optimization.to_optimize_tab', { count: namesToOptimizeCount })} sx={{ typography: 'titleSmall' }} />
    </Tabs>
  );
}
